import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Sidedash from '../uicomponents/Sidedash';
import { formatDate, capitalizeFirstLetter, convertSlotToTimings } from '../utils/Utilsfunc';
import AlertContext from '../../context/AlertContext';
import { useContext } from 'react';

const CheckoutPage = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { showAlert } = useContext(AlertContext);
    const [orderResponse] = useState(location.state?.orderResponse);
    const host = process.env.REACT_APP_BACKEND_URL;

    useEffect(() => {
        if (!orderResponse) {
            navigate('/profile');
        }
    }, [orderResponse, navigate]);

    const handlePayment = async () => {
        try {
            const options = {
                key: process.env.REACT_APP_RAZORPAY_KEY_ID,
                amount: orderResponse.order.amount * 100,
                currency: "INR",
                name: "BookBuddy Library",
                description: "Seat Booking/Renewal",
                order_id: orderResponse.order.orderId,
                handler: async (response) => {
                    try {
                        const verifyResponse = await fetch(`${host}/verify-payment`, {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json' },
                            body: JSON.stringify({
                                razorpay_order_id: response.razorpay_order_id,
                                razorpay_payment_id: response.razorpay_payment_id,
                                razorpay_signature: response.razorpay_signature
                            })
                        });

                        await verifyResponse.json();

                        if (verifyResponse.ok) {
                            showAlert("Payment successful! Redirecting to receipt...", "success");
                            navigate(`/transaction/${orderResponse.order.clientTxnId}`);
                        } else {
                            showAlert("Payment verification failed. Please contact support.", "danger");
                        }
                    } catch (error) {
                        console.error('Payment verification error:', error);
                        showAlert("Payment verification failed. Please contact support.", "danger");
                    }
                },
                prefill: {
                    name: orderResponse.order.customerName,
                    email: orderResponse.order.customerEmail,
                    contact: orderResponse.order.customerMobile
                },
                theme: {
                    color: "#1a092d"
                }
            };

            const rzp = new window.Razorpay(options);
            rzp.open();
        } catch (error) {
            console.error('Payment initialization error:', error);
            showAlert("Failed to initialize payment. Please try again.", "danger");
        }
    };

    if (!orderResponse) {
        return <div>No order details available.</div>;
    }

    return (
        <div className="container-fluid">
            <div className="row">
                <Sidedash />
                <div className="col-md-7 pt-3">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card border-top border-bottom border" style={{ borderColor: "#f37a27 !important" }}>
                                <div className="card-body p-5">
                                    <p className="lead fw-bold mb-5" style={{ color: "#f37a27" }}>Order Confirmation</p>

                                    <div className="row">
                                        <div className="col mb-3">
                                            <p className="small text-muted mb-1">Date</p>
                                            <p>{formatDate(orderResponse.order.createdAt)}</p>
                                        </div>
                                        <div className="col mb-3">
                                            <p className="small text-muted mb-1">Order No.</p>
                                            <p>{orderResponse.order.clientTxnId}</p>
                                        </div>
                                    </div>

                                    <div className="mx-n5 px-5 py-4" style={{ borderTop: "1px solid #f37a27", borderBottom: "1px solid #f37a27" }}>
                                        {orderResponse.order.seatDetails.map(seat => (
                                            <div key={`${seat.seatNumber}-${seat.slot}`} className="row">
                                                <div className="col-md-8 col-lg-9">
                                                    <p>Seat: {seat.seatNumber} - {convertSlotToTimings(seat.slot)} - <span className='badge text-bg-success'>{capitalizeFirstLetter(seat.type)}</span></p>
                                                </div>
                                                <div className="col-md-4 col-lg-3">
                                                    <p>₹350</p>
                                                </div>
                                            </div>
                                        ))}
                                        <div className="row" style={{ borderTop: "1px solid #f37a27" }}>
                                            <div className="col-md-8 col-lg-9 mt-2">
                                                <p className="mt-2 mb-0">Sub Total</p>
                                            </div>
                                            <div className="col-md-4 col-lg-3 mt-2">
                                                <p className="mt-2 mb-0">₹{orderResponse.order.totalPrice}</p>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-8 col-lg-9">
                                                <p className="text-success mt-1 mb-0">Discount</p>
                                            </div>
                                            <div className="col-md-4 col-lg-3">
                                                <p className="mb-0 mt-1 text-success">{(orderResponse.order.discountValue) ? "-" : ""}₹{orderResponse.order.discountValue}</p>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="mx-n5 px-5 py-4">
                                        <div className="row">
                                            <div className="col-md-8 col-lg-9">
                                                <p className="lead fw-bold mb-0" style={{ color: "#f37a27" }}>Total</p>
                                            </div>
                                            <div className="col-md-4 col-lg-3">
                                                <p className="lead fw-bold mb-0" style={{ color: "#f37a27" }}>₹{orderResponse.order.amount}</p>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-lg-12">
                                            <div className="horizontal-timeline">
                                                <div className="payment-links mb-4">
                                                    <p className="lead fw-bold" style={{ color: "#f37a27" }}>Complete your payment</p>
                                                    <button 
                                                        onClick={handlePayment}
                                                        className="btn btn-primary btn-lg w-100"
                                                        style={{ backgroundColor: "#1a092d", borderColor: "#1a092d" }}
                                                    >
                                                        Pay Now
                                                    </button>
                                                </div>

                                                <ul className="list-inline items d-flex justify-content-around">
                                                    <li className="list-inline-item items-list">
                                                        <p className="py-1 px-2 rounded text-white" style={{ backgroundColor: "#f37a27" }}>
                                                            <Link className='d-inline-block py-0 px-2 text-white text-decoration-none' to="/profile">Cancel</Link>
                                                        </p>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <p><small className="mt-4 pt-2 mb-0 text-muted">After clicking Pay Now, you will be redirected to the payment gateway. Please complete the payment to confirm your booking.</small></p>
                                    <p className="mt-4 pt-2 mb-0">Want any help? <a className='text-decoration-none' href="https://mail.google.com/mail/?view=cm&fs=1&to=info@bookbuddy.co.in&su=Need help with purchase/renewal&body=Hi there!" style={{ color: "#f37a27" }}>Please contact us!</a></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CheckoutPage;